import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {DataGrid} from "@mui/x-data-grid";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

import {useNavigate} from "react-router-dom";
import {useAuth} from "../../context/AuthContext";
import {getOrganizationById, getUsersList} from "../../services/requests/GraphRequests";
import CustomPagination from "../DataGrid/CustomPagination";
import CustomToolbar from "../DataGrid/CustomToolbar";
import GridCellExpand from "../DataGrid/GridCellExpand";


const UsersList = () => {
	let navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [users, setUsers] = useState(null);

	const currentUser = useAuth()

	const {t} = useTranslation();

	useEffect(() => {
		getUsersList()
			.then((data) => {
				const filtered = data.data.users?.filter(user => user.role !== 'SUPER_ADMIN' && user.role !== 'FISCAL_OFFICER');
				setUsers(filtered);
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);


	React.useEffect(() => {
		if (currentUser?.user?.organizationId) {
			getOrganizationById(currentUser.user.organizationId).then((data) => {
				if (!data) return

				setUsers(prevUsers => (prevUsers || [])?.map(user => ({
					...user,
					cashRegisterIds: data.data?.organization?.cashRegisters?.filter(item => user.cashRegisterIds.includes(item.id)).map(item => item.number + '')
				})))
				// setCashList(data.data.organization.cashRegisters.filter(item => !!item.number).map(item => ({
				// 	value: item.id + '',
				// 	label: item.number
				// })))
			});
		}
	}, [currentUser]);


	const columns = getColumns({t})


	if (loading) {
		return (
			<div align="center">
				<CircularProgress/>
			</div>
		);
	}

	const handleClickRow = (id) => {
		navigate(`/user/${id}`);

	}

	return (
		<Box
			sx={{flexGrow: 1, marginTop: 3, marginLeft: 10, marginBottom: 10}}
		>
			<Grid container sx={{marginTop: 2}} spacing={4} align="left">
				<Grid item xs={6}>
					<Typography
						sx={{fontSize: 24}}
						color="pimary"
						gutterBottom
					>
						{t('list_users')}
					</Typography>
				</Grid>
				<Grid item xs={5} align="right">
					<Button
						variant="outlined"
						onClick={() => {
							navigate(`/user/new`);
						}}
					>
						{t('add_user_btn')}
					</Button>
				</Grid>
			</Grid>
			<Grid container spacing={2} sx={{marginTop: 3}} align="left">
				<Grid item xs={11}>
					<DataGrid
						sx={{
							height: '520px',
						}}
						density={'compact'}
						components={{
							Toolbar: CustomToolbar,
							Pagination: CustomPagination,
						}}

						columns={columns || []}
						rows={users || []}
						pageSize={10}
						pagination
						onRowClick={(params) => handleClickRow(params.row.id)}
						rowsPerPageOptions={[10]}
					/>
				</Grid>
			</Grid>
		</Box>
	);
}

export default UsersList;


const getColumns = ({t}) => ([
		{
			field: 'id',
			headerName: t('id'),
			width: 90,
		},
		{
			field: 'login',
			headerName: t('login'),
			flex: 1,
			align: 'center',
			headerAlign: 'center',

		},
		{
			field: 'email',
			headerName: t('email'),
			flex: 1,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'role',
			headerName: t('role'),
			flex: 1,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'status',
			headerName: t('status'),
			flex: 1,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'cashRegisterIds',
			headerName: 'eKassa',
			flex: 1,
			renderCell: (params) => {
				const cashRegisterIds = (params.row.cashRegisterIds || [])?.join(', ');
				return (
					<GridCellExpand value={cashRegisterIds || ''} width={params.colDef.computedWidth}/>
				)
			}
		}
	]
)
